var map = {
	"./frontend/AndroidGuide.vue": 27396,
	"./frontend/Banking.vue": 87411,
	"./frontend/BetslipHistory.vue": 78137,
	"./frontend/BodyFB.vue": 72071,
	"./frontend/Commission.vue": 36053,
	"./frontend/ContactUs.vue": 35571,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 38114,
	"./frontend/History.vue": 13860,
	"./frontend/Home.vue": 44231,
	"./frontend/IOSGuide.vue": 87534,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 51250,
	"./frontend/Index.vue": 34918,
	"./frontend/Live.vue": 10080,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 43595,
	"./frontend/MaungFB.vue": 96272,
	"./frontend/Promotion.vue": 16814,
	"./frontend/Setting.vue": 22664,
	"./frontend/StreamerPublicReport.vue": 5849,
	"./frontend/VideoLink.vue": 96211,
	"./frontend/VipLevels.vue": 18314,
	"./frontend/Withdraw.vue": 59532,
	"./frontend/auth/Login.vue": 21836,
	"./frontend/auth/Register.vue": 51505,
	"./frontend/auth/Rule.vue": 77978,
	"./frontend/auth/Verify.vue": 49757,
	"./frontend/auth/VerifyNotAuth.vue": 47722,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 40093,
	"./frontend/components/FBPreviewVoucher.vue": 28833,
	"./frontend/components/FBVoucher.vue": 98108,
	"./frontend/components/FootballTeamCard.vue": 89188,
	"./frontend/components/GroupBox.vue": 48747,
	"./frontend/components/InputSelectDrawModal.vue": 90313,
	"./frontend/components/LuckyWheel.vue": 30187,
	"./frontend/components/NormalBox.vue": 63243,
	"./frontend/components/PreviewVoucher.vue": 5570,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 64059,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 89795,
	"./frontend/components/Voucher.vue": 74389,
	"./frontend/normal-user/2d/2d.vue": 44243,
	"./frontend/normal-user/2d/ClosedDays.vue": 10291,
	"./frontend/normal-user/2d/Home.vue": 68703,
	"./frontend/normal-user/2d/Winner.vue": 70630,
	"./frontend/normal-user/3d/3d.vue": 74681,
	"./frontend/normal-user/3d/Home.vue": 21079,
	"./frontend/normal-user/DreamBooks.vue": 61389,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 89164,
	"./frontend/normal-user/game/Arcade.vue": 53123,
	"./frontend/normal-user/game/Fishing.vue": 91055,
	"./frontend/normal-user/game/Game.vue": 10199,
	"./frontend/normal-user/game/Slot.vue": 96597,
	"./frontend/normal-user/shankomee/Room.vue": 79956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;